import useGlobalStore from '@/store/useGlobalStore'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

export const useCloseMenusOnPageChange = () => {
  const router = useRouter()
  const { setApp } = useGlobalStore()

  useEffect(() => {
    const closeAllMenus = () => {
      setApp({
        searchBarValue: '',
        isSearchBarActive: false,
        isCartOpen: !!router.query.cart,
        isMobileDrawerOpen: false,
      })
    }

    router.events.on('routeChangeStart', closeAllMenus)

    return () => {
      router.events.off('routeChangeStart', closeAllMenus)
    }
  }, [router.events, router.query.cart])
}
